import request from "@/utils/request";

export function bunchGet(params) {
    return request({
        url: "/api/services/app/Bunch/Get",
        method: "get",
        params
    });
}

export function bunchGetAll(params) {
    return request({
        url: "/api/services/app/Bunch/GetAll",
        method: "get",
        params
    });
}

export function bunchUpdate(data) {
    return request({
        url: "/api/services/app/Bunch/Update",
        method: "put",
        data
    });
}

export function bunchCreate(data) {
    return request({
        url: "/api/services/app/Bunch/Create",
        method: "POST",
        data
    });
}

export function bunchCreateMany(data) {
    return request({
        url: "/api/services/app/Bunch/CreateMany",
        method: "POST",
        data
    });
}

export function bunchDelete(params) {
    return request({
        url: "/api/services/app/Bunch/Delete",
        method: "DELETE",
        params
    });
}

export function bunchGetAllOptions(params) {
    return request({
        url: "/api/services/app/Bunch/GetAllForDropDown",
        method: "get",
        params
    });
}

export function bunchPatchMany(data) {
    return request({
        url: "/api/services/app/Bunch/PatchMany",
        method: "PATCH",
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/bunch.js